import "../assets/NcAppNavigationToggle-9e170630.css";
import l from "../Components/NcButton.mjs";
import "../Directives/Tooltip.mjs";
import { t as o } from "./l10n-ef44019c.mjs";
import { n as i } from "./_plugin-vue2_normalizer-71e2aa87.mjs";
import { VTooltip as r } from "floating-vue";
const s = {
  name: "MenuIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var c = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, p = [], _ = /* @__PURE__ */ i(
  s,
  c,
  p,
  !1,
  null,
  null,
  null,
  null
);
const u = _.exports, m = {
  name: "MenuOpenIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var f = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-open-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M21,15.61L19.59,17L14.58,12L19.59,7L21,8.39L17.44,12L21,15.61M3,6H16V8H3V6M3,13V11H13V13H3M3,18V16H16V18H3Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, v = [], d = /* @__PURE__ */ i(
  m,
  f,
  v,
  !1,
  null,
  null,
  null,
  null
);
const g = d.exports;
const h = {
  name: "NcAppNavigationToggle",
  directives: {
    tooltip: r
  },
  components: {
    NcButton: l,
    MenuIcon: u,
    MenuOpenIcon: g
  },
  props: {
    open: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["update:open"],
  computed: {
    label() {
      return this.open ? o("Close navigation") : o("Open navigation");
    }
  },
  methods: {
    toggleNavigation() {
      this.$emit("update:open", !this.open);
    }
  }
};
var N = function() {
  var t = this, e = t._self._c;
  return e("NcButton", { directives: [{ name: "tooltip", rawName: "v-tooltip.auto", value: t.label, expression: "label", modifiers: { auto: !0 } }], staticClass: "app-navigation-toggle", attrs: { type: "tertiary", "aria-expanded": t.open ? "true" : "false", "aria-label": t.label, "aria-controls": "app-navigation-vue" }, on: { click: t.toggleNavigation }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t.open ? e("MenuOpenIcon", { attrs: { size: 20 } }) : e("MenuIcon", { attrs: { size: 20 } })];
  }, proxy: !0 }]) });
}, b = [], y = /* @__PURE__ */ i(
  h,
  N,
  b,
  !1,
  null,
  "13b4f13a",
  null,
  null
);
const z = y.exports;
export {
  z as N
};
